import { Link, NavLink, Outlet } from "react-router-dom";
import { Coins, Phone, Mail } from "lucide-react";

const PHONE = "502-797-4958";
const PHONE_TEL = "+15027974958";
const EMAIL = "billcornett813@yahoo.com";

const PublicLayout = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-[#F3EFE0] flex flex-col">
      {/* Top contact strip */}
      <div className="bg-[#0A0A0A] border-b border-[#F3EFE0]/10 px-6 md:px-12 lg:px-24 py-2">
        <div className="flex flex-col sm:flex-row sm:justify-end items-center gap-2 sm:gap-8 text-xs text-[#A19D94]">
          <a
            href={`tel:${PHONE_TEL}`}
            className="inline-flex items-center gap-2 hover:text-[#D4AF37] transition-colors"
            data-testid="top-phone-link"
          >
            <Phone className="w-3.5 h-3.5" strokeWidth={1.5} />
            <span className="font-mono tracking-wide">{PHONE}</span>
          </a>
          <a
            href={`mailto:${EMAIL}`}
            className="inline-flex items-center gap-2 hover:text-[#D4AF37] transition-colors"
            data-testid="top-email-link"
          >
            <Mail className="w-3.5 h-3.5" strokeWidth={1.5} />
            <span className="font-mono tracking-wide">{EMAIL}</span>
          </a>
        </div>
      </div>

      <header className="sticky top-0 z-50 backdrop-blur-2xl bg-black/60 border-b border-[#F3EFE0]/10">
        <div className="px-6 md:px-12 lg:px-24 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
            <Coins className="w-6 h-6 text-[#D4AF37]" strokeWidth={1.5} />
            <span className="font-display text-2xl tracking-tight">Cornett Coins and Collectibles</span>
          </Link>
          <nav className="hidden md:flex items-center gap-10">
            <NavLink to="/" end className={({isActive}) => `coin-tag transition-colors ${isActive ? 'text-[#D4AF37]' : 'text-[#A19D94] hover:text-[#F3EFE0]'}`} data-testid="nav-home">Home</NavLink>
            <NavLink to="/catalog" className={({isActive}) => `coin-tag transition-colors ${isActive ? 'text-[#D4AF37]' : 'text-[#A19D94] hover:text-[#F3EFE0]'}`} data-testid="nav-catalog">Catalog</NavLink>
          </nav>
          <Link to="/admin/login" className="coin-tag text-[#A19D94] hover:text-[#D4AF37] transition-colors" data-testid="nav-admin">Admin</Link>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-[#F3EFE0]/10 px-6 md:px-12 lg:px-24 py-12 mt-24">
        <div className="grid md:grid-cols-3 gap-8 items-start">
          <div>
            <div className="font-display text-3xl mb-2">Cornett Coins &amp; Collectibles</div>
          </div>
          <div>
            <div className="coin-tag mb-3">Explore</div>
            <ul className="space-y-2 text-sm text-[#A19D94]">
              <li><Link to="/catalog" className="hover:text-[#D4AF37]">Full Catalog</Link></li>
              <li><Link to="/admin/login" className="hover:text-[#D4AF37]">Admin Portal</Link></li>
            </ul>
          </div>
          <div>
            <div className="coin-tag mb-3">Contact</div>
            <ul className="space-y-3 text-sm text-[#A19D94]">
              <li>
                <a
                  href={`tel:${PHONE_TEL}`}
                  className="inline-flex items-center gap-2 hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-phone-link"
                >
                  <Phone className="w-4 h-4" strokeWidth={1.5} />
                  <span className="font-mono">{PHONE}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  className="inline-flex items-center gap-2 hover:text-[#D4AF37] transition-colors break-all"
                  data-testid="footer-email-link"
                >
                  <Mail className="w-4 h-4 shrink-0" strokeWidth={1.5} />
                  <span className="font-mono">{EMAIL}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[#F3EFE0]/5 mt-12 pt-6 flex flex-col sm:flex-row justify-between text-xs text-[#6B6A65]">
          <span>© {new Date().getFullYear()} Cornett Coins &amp; Collectibles</span>
          <span className="font-mono">est. mmxxvi</span>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
